import * as Weather from './components/Weather.css';
export default {
    Weather
};
